export const TWITTER_URL = "https://twitter.com/tsrocketfactory";
export const INSTAGRAM_URL = "https://www.instagram.com/tsrocketfactory";
export const DISCORD_URL = "https://discord.gg/tomsachs";
